import { HELP_ITEM_ID } from '../../HelpMenu'

export const ITEMS_WITH_SUB_FLOW = new Set<string>([HELP_ITEM_ID.SHARE_FEEDBACK])
